import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import Registration from 'containers/forms/Registration'
import { getMissingRequiredInfo } from './loginSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import SocialButtons from './SocialButtons'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import Form from './Form'

const LOGIN_TYPES = {
  loginMail: 'login-mail',
  loginPhone: 'login-phone',
  registration: 'registration'
}

const LoginPopup = () => {
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const [type, setType] = useState(LOGIN_TYPES.login)
  const [isPassword, setPassword] = useState(false)

  const { replace, goBack } = useHistory()
  const { t } = useTranslation('form')
  const { t: tBasic } = useTranslation('basic')
  const callback = (payload) => {
    if (payload) {
      replace(
        getMissingRequiredInfo(payload)
          ? '/registration'
          : isBasketEmpty
            ? '/dashboard'
            : '/order/billing'
      )
    }
  }

  return (
    <Popup
      preventModalHidingAfterGestureIsPerformed
      preventClosingOutsidePopup={type === LOGIN_TYPES.registration}>
      {type === LOGIN_TYPES.registration
        ? <Registration
          className='registration__popup'
          callback={callback}
          goToLoginForm={() => {
            setType(LOGIN_TYPES.login)
          }}
          button={<div className='popup__closeBtn'>
            <button
              type='button'
              aria-label={tBasic('close')}
              title={tBasic('close')}
              onClick={goBack}>
              <i className='icon icon--close' />
            </button>
          </div>}
        />
        : <div className='login__popup login'>
          <div className='popup__title'>
            <i className='icon icon--logo' />
            <div>{t('logIn')}</div>
          </div>

          <div className='login__main'>
            <Form
              isPassword={isPassword}
              showMailForm={type === LOGIN_TYPES.loginMail}
              setMailForm={isMail => {
                setType(isMail ? LOGIN_TYPES.loginMail : LOGIN_TYPES.loginPhone)
              }}
              showPassword={setPassword}
              callback={callback}
              showRegistrationForm={() => {
                setType(LOGIN_TYPES.registration)
              }}
            />
            <div className='login__or'>
              <hr />
              <p>{t('or')}</p>
              <hr />
            </div>

            <div className='login__options'>
              {type === LOGIN_TYPES.loginMail
                ? <button
                  className='button--social'
                  onClick={() => {
                    setType(LOGIN_TYPES.loginPhone)
                  }}>
                  <i className='icon icon--phone' />
                  <span>{t('continueWithPhoneNumber')}</span>
                </button>
                : <button
                  className='button--social'
                  onClick={() => {
                    setType(LOGIN_TYPES.loginMail)
                  }}>
                  <i className='icon icon--mail' />
                  <span>{t('continueWithEmail')}</span>
                </button>}
              <SocialButtons />
            </div>
          </div>
        </div>}
    </Popup>
  )
}

export default LoginPopup